import React, { useEffect } from "react";
import { Table } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import { getEmployeeList, doEmployeeDelete } from "../../../../../redux/employee/employeeState";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";
import { handleTableChange } from "../../../../../utils/index";

const EmployeeTable = ({ recordList, pagination, doSearch, doDelete, filters, accountId }) => {
	const { getColumnSearchProps } = ColumnSearchFilter();
  	const columns = [
		{
	        title: `Employee ID`,
	        dataIndex: 'code',
	        key: 'code',
	        width: '12%',
	        sorter: true,
	        ...getColumnSearchProps('code'),
	        render:(code) => <span>{code}</span> 	       
	    },
	    {
	        title: `Employee Name`,
	        dataIndex: 'employee_name',
	        key: 'employee_name',
	        width: '20%',
	        sorter: true,
	        ...getColumnSearchProps('employee_name'),
	        render:(employee_name) => <span>{employee_name}</span> 	       
	    },
		{
	        title: `Job Title`,
	        dataIndex: 'job_title',
	        key: 'job_title',
	        width: '20%',
	        render:(job_title) => <span>{job_title}</span> 	       
	    },
	    {
	        title: `Assigned Farm`,
	        dataIndex: 'assigned_farm',
	        key: 'assigned_farm',
	        width: '20%',
	        sorter: true,
	        render:(assigned_farm) => <span>{assigned_farm}</span> 	       
	    },
	    {
	        title: <Button extra="btn-small">
			      		<a href={`/console/accounts/${accountId}/employees/add`}>
					        <PlusOutlined />{' '}Add
					  	</a>
			    	</Button>,
	        dataIndex: 'id',
	        key: 'id',
	        width: '10%',
	        render:(id) => <CrudOption baseRoute={`/console/accounts/${accountId}/employees`} recordId={id} deleteHandler={doDelete}/>
	    },
    ];
	
	useEffect(() => {
	    doSearch({paginate: pagination.per_page, accountId});
    }, [doSearch, pagination.per_page, accountId]);

  	return (
		<div className="h-full overflow-x-scroll xl:overflow-x-hidden mt-4">
			
			<SearchFilter placeholder="Search by Name or ID" searchHandler={doSearch} filters={filters} pagination={pagination}/>
		
			<Table
				dataSource={recordList} 
				columns={columns} 
				rowKey={(record) => record.id}
				pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
				onChange={handleTableChange(doSearch, filters)}  
			/>
		</div>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.employee.recordList?.items,
	pagination: state.employee.recordList?.pagination,
	filters: state.employee.recordList?.filters,
  	requesting: state.employee.recordList?.requesting,
  	error: state.employee.recordList?.error,
  
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getEmployeeList(filters)),
  doDelete: (id) => dispatch(doEmployeeDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeTable);